import { forwardRef } from "react";
import { FormMultiDatePickerCalendarProps } from "../Form.types";
import FormField, { useFormField } from "../FormField/FormField";
import { useController } from "react-hook-form";
import { MultiDatePickerCalendar } from "src/designsystem/MultiDatePickerCalendar/MultiDatePickerCalendar";

export const FormMultiDatePickerCalendar = forwardRef(
  (props: FormMultiDatePickerCalendarProps, _ref) => {
    const { formFieldProps, childProps } = useFormField(props);
    const { field } = useController({ name: childProps.name });
    return (
      <FormField {...formFieldProps}>
        <MultiDatePickerCalendar aria-label={formFieldProps.label} {...field} {...childProps} />
      </FormField>
    );
  }
);
